module.exports = __webpack_public_path__ + "img/Colonies Button Closed.80e32132.png";